<template>
  <button class="edit-button no-print" 
          :disabled="disabled"
          :class="[
            inputIsEditable
              ? 'edit-button-is-editable'
              : 'edit-button-is-not-editable',
            disabled ? 'edit-button-disabled' : ''
          ]" 
          @click="onClick">
    {{ inputIsEditable ? "保存" : "编辑" }}
  </button>
</template>

<script>
export default {
  props: {
    inputIsEditable: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      
      if (this.inputIsEditable) {
        this.$emit("onSave");
      } else {
        this.$emit("onEdit");
      }
    },
  },
};
</script>

<style lang="scss" scoped>


@media print {
  .no-print {
    background-color: white !important;;
  }
}

.edit-button {
  color: white;
  border-radius: 4px;
  width: 88px;
  height: 32px;
  border: none;
  cursor: pointer;

  &-is-editable {
    background-color: #6cc291;
  }

  &-is-not-editable {
    background-color: #325FAC;
  }
  
  &-disabled {
    background-color: #ccc !important;
    color: #666 !important;
    cursor: not-allowed !important;
    opacity: 0.6;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
}
</style>